export const SET_ALL_AGENTS = 'SET_ALL_AGENTS';
export const SET_AGENTS = 'SET_AGENTS';
export const SET_CURRENT_SESSION = 'SET_CURRENT_SESSION';
export const SET_DEVICE_TOKEN = 'SET_DEVICE_TOKEN';
export const SET_AGENT_ANSWERS = 'SET_AGENT_ANSWERS';
export const SET_ERRORS = 'SET_ERRORS';
